<template>
  <div class="CosmeticTagPage">
    <!-- <img class="bgImg" src="https://apkpic.86122m.com/custom/5cd69273eab20d6e58a5aee5c21e5b9f.png" /> -->
    <div class="hzpContent" :style="{backgroundImage: 'url(' + item.bgImg + ')'}" v-if="active == 1">
      <img src="https://apkpic.86122m.com/custom/f44fd9431d057af2dc99f77f25f5130c.png" class="smallSplit"/>
      <img src="https://apkpic.86122m.com/custom/9012e647afd2b98f584f228465408d00.png" class="smallTag" />
      <div class="pageTitle">
        {{ item.title }}
      </div>

      <div class="infoBlock" v-for="(infoItem) in item.infoWrap" :key="infoItem.chTitle">
        <div class="infoEnTitle">
          {{ infoItem.enTitle }}
        </div>
        <div class="infoChTitle">
          {{ infoItem.chTitle }}
        </div>
        <img src="https://apkpic.86122m.com/custom/ec25e8749a4dd7d8e052625bb1cfae73.png" class="zsImg" />
        <div class="infoList" :class="{'infoList2': infoItem.type == 2}">
            <div class="infoItem" :class="{'infoItem2': infoItem.type == 2}" v-for="(listItem, listIndex) in infoItem.list" :key="listIndex">
              <div class="itemLabel">
                {{ listItem.title }}
              </div>
              <div class="itemValue">
                {{ listItem.msg }}
              </div>
            </div>
        </div>
      </div>
    </div>
    <div v-else-if="active == 2" class="fwContent" :style="[{backgroundColor:item.bgColor},{ padding: item.paddTop+'px' +' '+ item.paddRight+'px'+' '+ item.paddBottom+'px'+ ' '+item.paddLeft+'px' },{ backgroundImage: `url(${item.boxBg})`},{ backgroundRepeat: 'no-repeat'}, {backgroundSize: '100% 100%'}]">
        <div class="fwEnTitle" :style="[{fontSize: item.SubheadingSize + 'px'}, {color: item.SubheadingColor}]">Anti-counterfeit QR code</div>
        <div class="fwChTitle" :style="[{fontSize: item.titleSize + 'px'}, {color: item.titleColor}]">防伪二维码</div>
        <div class="ewmBox">
          <div class="ewmLeftBox2" :style="{ paddingTop: item.scanTop + 'px', paddingLeft: item.scanLeft + 'px' ,backgroundImage: `url(${item.scanBg})`}">
            <vue-qr
              :size="item.scanSize ? item.scanSize : 100"
              :margin="0"
              :auto-color="true"
              :dot-scale="1"
              text="123"
            />
            <div class="yzCode" v-if="item.showVerCode && item.showVerCode == 2" :style="{ paddingTop: item.scanBottom + 'px' }">86.122.2/lan202102261</div>
          </div>
          <div class="ewmRightBox">
            <img src="https://apkpic.86122m.com/custom/5e9efa2cc1dd8587a5254c26ea9b444e.png" class="veridicalTitle veridicalTitle1" v-if="item.encodingType && item.encodingType == 1"/>
            <img src="https://apkpic.86122m.com/custom/aab3ac8dc3db6a3312d4fca04e4bba43.png" class="veridicalTitle" v-else/>
            <div class="myVerBox myVerBox1" v-if="item.encodingType && item.encodingType == 1">
              <input placeholder="请输入验证码" />
              <button :style="{backgroundColor: `${item.btnBgColor}`}">验证</button>
            </div>
            <div class="myVerBox" v-else>
              <input placeholder="请输入验证码" />
              <button :style="{backgroundColor: `${item.btnBgColor}`}">验证</button>
            </div>

            <!-- <div style="height: 35px;">
              <div class="errTip" v-if="errTip">请输入验证码进行验证</div>
              <div class="verRes">
                <div v-if="verState === 1">
                  <span class="red">您好，验证成功，您购买的是正品,请放心使用！</span>
                </div>
                <div v-if="verState === 2">
                  <span class="red">您好，验证码无效，请谨防假冒！</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
       <div class="myboxWrap">
          <div class="myBox1" :style="[{fontSize: item.myBoxFize + 'px'}, {color: item.myBoxColor}]"><img src="https://apkpic.86122m.com/custom/37b2696fec21731b1a29adf85f048a87.png" class="dotImg" v-if="item.myboxWrapImg == 1"/>对比实物标签与图片</div>
          <div class="myBox2" :style="[{fontSize: item.myBoxFize + 'px'}, {color: item.myBoxColor}]"><img src="https://apkpic.86122m.com/custom/a9a126ba98903597fd7afc2807f18eb1.png" class="dotImg" v-if="item.myboxWrapImg == 1"/>观察图片中的文字、位置、编码是否相符</div>
          <div class="myBox3"><img :src="item.myBoxTipImg ? item.myBoxTipImg : 'https://apkpic.86122m.com/custom/87c3448782aca357bfdd6b08594b1081.png'" class="tipImg"/></div>
        </div>
        <!---区别开始-->
          <div class="style2_msgBox2 style2_msgBox1" v-if="item.encodingType && item.encodingType == 1">
            
            <template v-if="item.jumpStyle !== 1">
            <div v-if="item.jumpStyle === 2">
              <img class="jumpButton1" src="https://apkpic.86122m.com/custom/8569776c96884d28f9ddaad6767e6c61.png" />
            </div>
            </template>
            <div class="cxjg"><img src="https://apkpic.86122m.com/custom/5aa8723e53b2cf50e37a8782c0cd4bee.png" class="cxjgDot"/>查询结果</div>
            <div class="style2_msgBox4" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询时间为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
            <div class="style2_msgBox5" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询地点为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
          </div>
        <!---区别结束-->
        <div class="style2_msgBox2" v-else>
          <div class="gxbBox">
            <img src="https://apkpic.86122m.com/custom/242a0fae102194bd5855a7b121fd6c80.png" class="gxbIcon"/>
            <div class="rightContent">
              <p class="rightText1" :style="[{fontSize: item.codeTitleFize + 'px'}, {color: item.codeTitleColor}]">工业互联网标识码：</p>
              <p class="rightText2" :style="[{fontSize: item.codeContentFize + 'px'}, {color: item.codeContentColor}]">86.122.2/XXXXXX</p>
            </div>
          </div>

          <template v-if="item.jumpStyle !== 1">
          <div v-if="item.jumpStyle === 2">
             <img class="jumpButton1" src="https://apkpic.86122m.com/custom/8569776c96884d28f9ddaad6767e6c61.png" />
          </div>
          </template>

          <div class="style2_msgBox3" :style="[{fontSize: item.msgBox3Fize + 'px'}, {color: item.msgBox3Color}]">由国家工信部授权工业互联网标识解析二级节点（86.122）签发</div>
          <div class="style2_msgBox4" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询时间为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
          <div class="style2_msgBox5" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询地点为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
        </div>
        <div class="style2_msgBox6" :style="[{fontSize: item.msgBox6Fize + 'px'}, {color: item.msgBox6Color}]">
          <img src="https://apkpic.86122m.com/custom/b87f498ac4c07ebf2cbe7d370a05431b.png" class="cxIcon"/>
          现在是第<span class="orange" :style="[{fontSize: item.msgBox7Fize + 'px'}, {color: item.msgBox7Color}]">--</span>次查询
        </div>
    </div>
    <!--防伪营销页面 开始-->
    <div v-else-if="active == 3" class="yxContent">
      <!--防伪上边轮播图-->
      <van-swipe
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="(picItem,index) in item.swipePicList" :key="picItem.url+index">
          <van-image
            width="100%"
            :src="picItem.url"
            class="vanImgs"
          />
        </van-swipe-item>
      </van-swipe>
      <!---防伪上边自定义图片--->
      <div :style="styleObject">
        <div v-for="(picItem,index) in item.picList" :key="picItem.url + index" :style="imgStyle(picItem,item)">
          <div>
            <img
              width="100%"
              :src="picItem.url"
              style="min-height: 20px; display: block;"
            />
          </div>
        </div>
        <div style="clear: both" />
         <!---防伪上边自定义视频--->
        <div v-for="(videoItem, index) in item.videoList" :key="videoItem.url + index">
        <video class="myVideo" 
          controls="controls" 
          :src="videoItem.url" 
          :width="videoItem.videoWidth? videoItem.videoWidth : '100%'"
          :height="videoItem.videoHeight ? videoItem.videoHeight : 'auto'">
        </video>
        </div>

        <div class="fwContent" :style="[{backgroundColor:item.bgColor},{ padding: item.paddTop+'px' +' '+ item.paddRight+'px'+' '+ item.paddBottom+'px'+ ' '+item.paddLeft+'px' },{ backgroundImage: `url(${item.boxBg})`},{ backgroundRepeat: 'no-repeat'}, {backgroundSize: '100% 100%'}]">
            <div class="fwEnTitle" :style="[{fontSize: item.SubheadingSize + 'px'}, {color: item.SubheadingColor}]">Anti-counterfeit QR code</div>
            <div class="fwChTitle" :style="[{fontSize: item.titleSize + 'px'}, {color: item.titleColor}]">防伪二维码</div>
            <div class="ewmBox">
              <div class="ewmLeftBox2" :style="{ paddingTop: item.scanTop + 'px', paddingLeft: item.scanLeft + 'px' ,backgroundImage: `url(${item.scanBg})`}">
                <vue-qr
                  :size="item.scanSize ? item.scanSize : 100"
                  :margin="0"
                  :auto-color="true"
                  :dot-scale="1"
                  text="123"
                />
                <div class="yzCode" v-if="item.showVerCode && item.showVerCode == 2" :style="{ paddingTop: item.scanBottom + 'px' }">86.122.2/lan202102261</div>
              </div>
              <div class="ewmRightBox">
                <img src="https://apkpic.86122m.com/custom/5e9efa2cc1dd8587a5254c26ea9b444e.png" class="veridicalTitle veridicalTitle1" v-if="item.encodingType && item.encodingType == 1"/>
                <img src="https://apkpic.86122m.com/custom/aab3ac8dc3db6a3312d4fca04e4bba43.png" class="veridicalTitle" v-else/>
                
                <div class="myVerBox myVerBox1" v-if="item.encodingType && item.encodingType == 1">
                  <input placeholder="请输入验证码" />
                  <button :style="{backgroundColor: `${item.btnBgColor}`}">验证</button>
                </div>
                <div class="myVerBox" v-else>
                  <input placeholder="请输入验证码" />
                  <button :style="{backgroundColor: `${item.btnBgColor}`}">验证</button>
                </div>

                <!-- <div style="height: 35px;">
                  <div class="errTip" v-if="errTip">请输入验证码进行验证</div>
                  <div class="verRes">
                    <div v-if="verState === 1">
                      <span class="red">您好，验证成功，您购买的是正品,请放心使用！</span>
                    </div>
                    <div v-if="verState === 2">
                      <span class="red">您好，验证码无效，请谨防假冒！</span>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          <div class="myboxWrap">
              <div class="myBox1" :style="[{fontSize: item.myBoxFize + 'px'}, {color: item.myBoxColor}]"><img src="https://apkpic.86122m.com/custom/37b2696fec21731b1a29adf85f048a87.png" class="dotImg" v-if="item.myboxWrapImg == 1"/>对比实物标签与图片</div>
              <div class="myBox2" :style="[{fontSize: item.myBoxFize + 'px'}, {color: item.myBoxColor}]"><img src="https://apkpic.86122m.com/custom/a9a126ba98903597fd7afc2807f18eb1.png" class="dotImg" v-if="item.myboxWrapImg == 1"/>观察图片中的文字、位置、编码是否相符</div>
              <div class="myBox3"><img :src="item.myBoxTipImg ? item.myBoxTipImg : 'https://apkpic.86122m.com/custom/87c3448782aca357bfdd6b08594b1081.png'" class="tipImg"/></div>
            </div>
            <!---区别开始-->
             <div class="style2_msgBox2 style2_msgBox1" v-if="item.encodingType && item.encodingType == 1">
              
              <template v-if="item.jumpStyle !== 1">
              <div v-if="item.jumpStyle === 2">
                <img class="jumpButton1" src="https://apkpic.86122m.com/custom/8569776c96884d28f9ddaad6767e6c61.png" />
              </div>
              </template>
              <div class="cxjg"><img src="https://apkpic.86122m.com/custom/5aa8723e53b2cf50e37a8782c0cd4bee.png" class="cxjgDot"/>查询结果</div>
              <div class="style2_msgBox4" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询时间为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
              <div class="style2_msgBox5" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询地点为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
            </div>
             <!---区别结束-->
            <div class="style2_msgBox2" v-else>
              <div class="gxbBox">
                <img src="https://apkpic.86122m.com/custom/242a0fae102194bd5855a7b121fd6c80.png" class="gxbIcon"/>
                <div class="rightContent">
                  <p class="rightText1" :style="[{fontSize: item.codeTitleFize + 'px'}, {color: item.codeTitleColor}]">工业互联网标识码：</p>
                  <p class="rightText2" :style="[{fontSize: item.codeContentFize + 'px'}, {color: item.codeContentColor}]">86.122.2/XXXXXX</p>
                </div>
              </div>

              <template v-if="item.jumpStyle !== 1">
              <div v-if="item.jumpStyle === 2">
                <img class="jumpButton1" src="https://apkpic.86122m.com/custom/8569776c96884d28f9ddaad6767e6c61.png" />
              </div>
              </template>

              <div class="style2_msgBox3" :style="[{fontSize: item.msgBox3Fize + 'px'}, {color: item.msgBox3Color}]">由国家工信部授权工业互联网标识解析二级节点（86.122）签发</div>
              <div class="style2_msgBox4" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询时间为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
              <div class="style2_msgBox5" :style="[{fontSize: item.msgBox4Fize + 'px'}, {color: item.msgBox4Color}]">初次查询地点为：<span class="orange" :style="[{fontSize: item.msgBox5Fize + 'px'}, {color: item.msgBox5Color}]">-----</span></div>
            </div>
            <div class="style2_msgBox6" :style="[{fontSize: item.msgBox6Fize + 'px'}, {color: item.msgBox6Color}]">
              <img src="https://apkpic.86122m.com/custom/b87f498ac4c07ebf2cbe7d370a05431b.png" class="cxIcon"/>
              现在是第<span class="orange" :style="[{fontSize: item.msgBox7Fize + 'px'}, {color: item.msgBox7Color}]">--</span>次查询
            </div>
        </div>
         <!---防伪下边自定义图片--->
        <div v-for="(picItem,index) in item.picList2" :key="picItem.url + index" :style="imgStyle2(picItem,item)">
          <div>
            <img
              width="100%"
              :src="picItem.url"
              style="min-height: 20px; display: block;"
            />
          </div>
        </div>
        <div style="clear: both" />
        <!---防伪下边自定义视频--->
        <div v-for="(videoItem, index) in item.videoList2" :key="videoItem.url + index">
        <video class="myVideo" 
          controls="controls" 
          :src="videoItem.url" 
          :width="videoItem.videoWidth? videoItem.videoWidth : '100%'"
          :height="videoItem.videoHeight ? videoItem.videoHeight : 'auto'">
        </video>
        </div>

        <!--商品组开始-->
         <div :style="spStyleObject" class="spGroup">
          <div>
            <div v-if="item.spSubTitleVisible" class="subTitle">{{item.spSubTitle}}</div>
            <div v-if="item.spTitleVisible" class="title">{{item.spTitle}}</div>
            <template v-if="item.listStyle === 1">
              <div class="productWrapper1">
                <div class="productBlock" v-for="proItem in item.productList" :key="proItem.goodsName" @click="goDetailPage(proItem)" :style="{backgroundColor: `${item.spProBgColor}`}">
                  <template v-if="item.spTopIconStyleType!==0">
                    <div v-if="item.spTopIconStyle === 1" class="topIcon1" >{{item.spTopIconTxt}}</div>
                    <div v-if="item.spTopIconStyle === 2" class="topIcon2" >{{item.spTopIconTxt}}</div>
                    <div v-if="item.spTopIconStyle === 3" class="topIcon3" >{{item.spTopIconTxt}}</div>
                  </template>
                  <div class="imgWrap" :style="[{backgroundImage: `url(${proItem.goodPhoto})`, height:`${item.spImgHeight}px`}]"></div>
                  <div class="goosName" v-if="item.spGoodsNameVisible" :style="{color: item.spGoodsNameColor}">{{proItem.goodsName}}</div>
                  <div class="goosPrice" v-if="item.spPriceVisible" :style="{color: item.spPriceColor}"><span class="symbol">￥</span>{{proItem.price}}</div>
                  <div class="buyButtonWrap" v-if="item.spBuyButtonStyle!==0">
                    <div class="button1" v-if="item.spBuyButtonStyle===1" :style="{borderColor: item.spBuyButtonColor, color: item.spBuyButtonColor}">询问</div>
                    <div class="button2" v-else-if="item.spBuyButtonStyle===2" :style="{borderColor: item.spBuyButtonColor, backgroundColor: item.spBuyButtonColor}">询问</div>
                    <div class="button3" v-else-if="item.spBuyButtonStyle===3" :style="{borderColor: item.spBuyButtonColor, backgroundColor: item.spBuyButtonColor}">立即抢购</div>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="item.listStyle === 2">
              <div class="productWrapper2 clearfix">
                <div class="productBlock" v-for="proItem in item.productList" :key="proItem.goodsName" @click="goDetailPage(proItem)" :style="{backgroundColor: `${item.spProBgColor}`}">
                  <template v-if="item.spTopIconStyleType!==0">
                    <div v-if="item.spTopIconStyle === 1" class="topIcon1" >{{item.spTopIconTxt}}</div>
                    <div v-if="item.spTopIconStyle === 2" class="topIcon2" >{{item.spTopIconTxt}}</div>
                    <div v-if="item.spTopIconStyle === 3" class="topIcon3" >{{item.spTopIconTxt}}</div>
                  </template>
                  <div class="imgWrap" :style="[{backgroundImage: `url(${proItem.goodPhoto})`, height: `${item.spImgHeight}px`}]"></div>
                  <div class="goosName" v-if="item.spGoodsNameVisible" :style="{color: item.spGoodsNameColor}">{{proItem.goodsName}}</div>
                  <div class="goosPrice" v-if="item.spPriceVisible" :style="{color: item.spPriceColor}"><span class="symbol">￥</span>{{proItem.price}}</div>
                  <div class="buyButtonWrap" v-if="item.spBuyButtonStyle!==0">
                    <div class="button1" v-if="item.spBuyButtonStyle===1" :style="{borderColor: item.spBuyButtonColor, color: item.spBuyButtonColor}">询问</div>
                    <div class="button2" v-if="item.spBuyButtonStyle===2" :style="{borderColor: item.spBuyButtonColor, backgroundColor: item.spBuyButtonColor}">询问</div>
                    <div class="button3" v-else-if="item.spBuyButtonStyle===3" :style="{borderColor: item.spBuyButtonColor, backgroundColor: item.spBuyButtonColor}">立即抢购</div>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="item.listStyle === 3">
              <div class="productWrapper3">
                <div class="productBlock" v-for="proItem in item.productList" :key="proItem.goodsName" @click="toMiniProgram(proItem)" :style="{backgroundColor: `${item.spProBgColor}`}">
                  <template v-if="item.spTopIconStyleType!==0">
                    <div v-if="item.spTopIconStyle === 1" class="topIcon1" >{{item.spTopIconTxt}}</div>
                    <div v-if="item.spTopIconStyle === 2" class="topIcon2" >{{item.spTopIconTxt}}</div>
                    <div v-if="item.spTopIconStyle === 3" class="topIcon3" >{{item.spTopIconTxt}}</div>
                  </template>
                  <div class="imgWrap" :style="[{backgroundImage: `url(${proItem.goodPhoto})`,height: `${item.spImgHeight}px`}]"></div>
                  <div class="rightBox">
                    <div class="goosName" v-if="item.spGoodsNameVisible" :style="{color: item.spGoodsNameColor}">{{proItem.goodsName}}</div>
                    <div class="goosPrice" v-if="item.spPriceVisible" :style="{color: item.spPriceColor}"><span class="symbol">￥</span>{{proItem.price}}</div>
                    <div class="buyButtonWrap" v-if="item.spBuyButtonStyle!==0">
                      <div class="button1" v-if="item.spBuyButtonStyle===1" :style="{borderColor: item.spBuyButtonColor, color: item.spBuyButtonColor}">询问</div>
                      <div class="button2" v-if="item.spBuyButtonStyle===2" :style="{borderColor: item.spBuyButtonColor, backgroundColor: item.spBuyButtonColor}">询问</div>
                      <div class="button3" v-else-if="item.spBuyButtonStyle===3" :style="{borderColor: item.spBuyButtonColor, backgroundColor: item.spBuyButtonColor}">立即抢购</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

          </div>
        </div>

        <!--商品组结束-->

        <div class="diymenu">
          <div class="item goShopButton" :style="{backgroundColor: item.rtBtnBgColor, width: `${item.rtBtnWidth}%`, color: item.rtTextColor}">
            <img class="cart_icon" src="https://apkpic.86122m.com/yimai_photos/customPage/template/221646961587_.pic.jpg" />
            <span>{{item.lfBtnText?item.lfBtnText : '商城'}}</span>
          </div>
          <div v-if="!(item.showZx && item.showZx == 2)" class="item kfButton" :style="{backgroundColor: item.lfBtnBgColor, width: `${item.lfBtnWidth}%`, color: item.lfTextColor}" :dataKey="item.zx_key">
            <img class="zx_icon" src="https://apkpic.86122m.com/yimai_photos/customPage/template/251646961619_.pic.jpg" />
            <div>{{item.rtBtnText ? item.rtBtnText : '咨询'}}</div>
          </div>
        </div>

      </div>
    </div>
    <!--防伪营销页面 结束-->
    <div class="botomTab" v-if="hasActiveButton">
      <div v-for="(btnItem, index) in item.btnList" :key="index" :class="{'active': btnItem.num == active}" @click="btnClick(btnItem.num)" v-show="btnItem.type">
        {{ btnItem.text }}
      </div>  
    </div>
  </div>
</template>
<script>
import { Image as VanImage, Swipe, SwipeItem } from "vant";
import VueQr from "vue-qr";
export default {
  data() {
    return {
      active: 1
    }
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [VanImage.name]: VanImage,
    VueQr,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    verState: Number,
    handleLink: String,
    handle: String,
    query: {
      type: String,
    },
    h: {
      type: String,
    },
    codeData: {
      type: Object,
    },
  },
  computed: {
    // 检查是否至少有一个按钮的 type 为 true
    hasActiveButton() {
      if (!this.item || !this.item.btnList || !this.item.btnList.length) {
        return false;
      }
      return this.item.btnList.some(btnItem => btnItem.type === true);
    },
    styleObject() {
      return {
        padding: this.item.yxPaddTop + 'px' + ' ' + this.item.yxPaddRight + 'px' + ' '+ this.item.yxPaddBottom + 'px' + ' ' + this.item.yxPaddLeft + 'px'
      }
    },
    imgStyle() {
      return (n, item) => {
        var wid
        var pos
        var str
        pos = item.align
        if (n.width) {
          wid = n.width
        } else {
          wid = '100%'
        }
        str = 'width: ' + wid
        if (pos === 'left') {
          console.log('pos', pos)
          str = `width: ${wid};float: ${pos}`
        } else if (pos === 'right') {
          console.log('pos', pos)
          str = `width: ${wid};float: ${pos}`
        } else if (pos === 'center') {
          console.log('pos', pos)
          str = `width: ${wid};margin: 0 auto;`
        }

        return str
      }
    },
    imgStyle2() {
      return (n, item) => {
        var wid
        var pos
        var str
        pos = item.align2
        if (n.width) {
          wid = n.width
        } else {
          wid = '100%'
        }
        str = 'width: ' + wid
        if (pos === 'left') {
          console.log('pos', pos)
          str = `width: ${wid};float: ${pos}`
        } else if (pos === 'right') {
          console.log('pos', pos)
          str = `width: ${wid};float: ${pos}`
        } else if (pos === 'center') {
          console.log('pos', pos)
          str = `width: ${wid};margin: 0 auto;`
        }

        return str
      }
    },
    // 商品组
    spStyleObject() {
      return {
        backgroundColor: this.item.spBgColor,
        backgroundImage: `url(${this.item.spBgUrl})`,
        backgroundImageSize: '100% 100%',
        backgroundRepeat: 'no-repeat'        
      }
    }
  },
  mounted() {
    
  },
  methods: {
    btnClick(num) {
      this.$set(this, 'active', num);
    },
    goDetailPage(data) {
      let {cardId, goodsId} = data
      console.log(data)
      uni.navigateTo({
          url: `/pages/productDetail/index?goodsId=${goodsId}&cardId=${cardId}&from=1`
      });
    }
  },
};
</script>
<style scoped lang="scss">
.CosmeticTagPage{
  position: relative;
  // min-height: 100vh;
  // background: url('https://apkpic.86122m.com/custom/5cd69273eab20d6e58a5aee5c21e5b9f.png') center top no-repeat;
  .hzpContent, .fwContent{
     background-size: cover;
     padding-bottom: 10px;
  }
  .fwContent{
    background: url('https://apkpic.86122m.com/custom/ce1b8695356db38a53485fff03e7a497.png') center top no-repeat;
    background-size: cover;
    padding-bottom: 95px;
    padding-top: 41px;
    .fwEnTitle{
      font-family: Omnes;
      font-weight: 300;
      font-size: 12px;
      color: #808080;
      text-align: center;
      padding: 0px 0 12px;
    }
    .fwChTitle{
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 25px;
      color: #333333;
      text-align: center;
      padding-bottom: 32px;
    }
    .ewmBox{
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      width: 100%;
      .ewmLeftBox2{
        width: 128px;
        height: 184px;
        background: url('https://apkpic.86122m.com/custom/afac8421c1949dba82629a0c2163bffd.png') center top no-repeat;
        background-size: 100% 100%;
        padding-top: 60px;
        box-sizing: border-box;
        .yzCode{
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 10px;
          color: #333333;
        }
      }
      .ewmRightBox{
        .veridicalTitle{
          width: 184px;
          margin-bottom: 25px;
        }
        .myVerBox{
          position: relative;
          width: 184px;
          text-align: left;
          input {
              display: inline-block;
              width: calc( 100% - 48px);
              height: 35px;
              box-sizing: border-box;
              line-height: 35px;
              padding-left: 5px;
              font-size: 12px;
              text-align: left;
              border-right: none;
              border: none;
              background-color: rgba(86, 150, 208, 0.1);
              border-radius: 5px 0 0 5px;
            }
            button{
              width: 48px;
              height: 35px;
              text-align: center;
              line-height:35px;
              font-size: 12px;
              background: #5197f6;
              color: #fff;
              /* margin: 5px 0; */
              border-radius: 5px;
              display: inline-block;
              outline: none;
              border: none;
              position: absolute;
              top: 0;
              right: 0;
            }
        }
        .myVerBox1 {
          input{
             width: 100%;
             background: rgba(86, 150, 208, 0.1);
             border-radius: 10rpx;
          }
          button {
            position: relative;
            height: 40px;
            background: #5197F6;
            border-radius: 5px;
            width: 100%;
            margin-top: 13px;
          }
        }
      }
    }

    .myboxWrap{
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      text-align: left;
      padding-left: 18px;
      padding-top: 30px;
      .dotImg{
        width: 12px;
        height: 13px;
        display: inline-block;
        margin-right: 18px;
      }
      .myBox1,.myBox2{
        padding-bottom: 15px;
      }
      .myBox3 .tipImg{
        width: 245px;
        height: 14px;
      }
    }

    .style2_msgBox2{
      width: 95%;
      min-height: 168px;
      margin: 22px auto 17px;
      background: url('https://apkpic.86122m.com/custom/91151f6e67a1a3d9b1a7f130e7acb836.png') center top no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px 18px;
      position: relative;
      .gxbBox{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        .gxbIcon{
          width: 30px;
          height: 30px;
          margin-right: 12px;
        }
        .rightContent {
          .rightText1{
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #333333;
            text-align: left;
            line-height: 20px;
            margin: 0;
          }
          .rightText2{
            font-family: Source Han Sans CN;
            font-weight: bold;
            font-size: 14px;
            color: #4A8FEC;
            text-align: left;
            line-height: 20px;
            margin: 0;
          }
        }
      }
      
    }
    .style2_msgBox1{
      background: none;
      margin: 0;
      min-height: auto;
      padding: 10px 18px 0;
      .cxjg{
        font-family: Source Han Sans CN;
        font-size: 14px;
        color: #333333;
        text-align: left;
        font-style: italic;
        padding-bottom: 10px;
        position: relative;
        padding-left: 5px;
        font-weight: 600;
        .cxjgDot{
          width: 12px;
          height: 12px;
          position: absolute;
          z-index: 0;
          left: 0;
          top:4px;
        }
      }
    }

    .style2_msgBox3{
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 11px;
      color: #515151;
      text-align: left;
      padding: 8px 0 14px;
    }
    .style2_msgBox4, .style2_msgBox5{
      min-height: 25px;
      background: rgba(86, 150, 208, 0.1);
      border-radius: 1px;
      padding: 7px 16px;
      box-sizing: border-box;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 11px;
      color: #333333;
      text-align: left;
      margin-bottom: 13px;
      .orange{
        color: #e8990f;
      }
    }
    .style2_msgBox6{
      text-align: left;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      .cxIcon{
        width: 25px;
        height: 25px;
        margin-right: 7px;
        margin-left: 24px;
      }
      .orange{
        color: #e8990f;
      }
      
    }
    
  }
  .smallSplit{
    width: 351px;
    height: 15px;
    margin: 27px auto 34px;
    display:inline-block;
  }
  .smallTag{
      width: 176px;
      height: 24px;
      margin: 0 auto 16px;
      display:inline-block;
    }
    .pageTitle{
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 30px;
      color: #1C71E3;
      line-height: 73rpx;
      text-align: center;
      padding-bottom: 30px;
    }
    
    .infoBlock{
        width: 343px;
        background: rgba(255,255,255,0.6);
        border-radius: 15px;
        padding: 20px 15px;
        margin: 10px auto;
        box-sizing: border-box;
        .infoEnTitle{
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 9px;
          color: #292B2F;
          line-height: 37px;
          text-align: left;

        }
        .infoChTitle{
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 24px;
          color: #292B2F;
          line-height: 37px;
          text-align: left;
        }
        .zsImg{
          width: 98px;
          height: 5px;
          display: block;
          margin: 10px 0;
        }
        .infoList{
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          align-items: stretch;
          padding-top: 20px;
          .infoItem{
            width: 100%;
            border-bottom: 1px solid rgba(193, 200, 213, 0.6);
            margin-bottom: 18px;
            text-align: left;
            .itemLabel{
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 12px;
              color: #292B2F;
              line-height: 37rpx;
            }
            .itemValue{
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 15px;
              color: #292B2F;
              line-height: 35px;
           }
          }
          
        }
        .infoList2{
          display: block;
          .infoItem2{
            width: 100%;
          }
        }
        
    }
  .botomTab{
    // position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 85px;
    background: #EEF2F8;
    box-shadow: 0px 1px 13.5px 0px rgba(205,212,219,0.6);
    display: flex;
    justify-content: space-around;
    align-items: center;
    > div {
      display: inline-block;
      min-width: 110.5px;
      height: 44.5px;
      border-radius: 22px;
      text-align: center;
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 15px;
      line-height: 44.5px;
      background: #C1DBFF;
      border: 1px solid #5197F6;
      color: #1C71E3;
      cursor: pointer;
      &.active{
        background: #5197F6;
        color: #FFFFFF;
        border: 1px solid #5197F6;        
      }
    }
    
  }
}

.jumpButton1{
      position: absolute;
      right: -10px;
      top: 0px;
      width: 136px;
      height: 42px;
    }



.diymenu{
  /* position: absolute;
  bottom: 0;
  left: 0;
  right: 0; */
  width: 100%;
  height: 50px;
  border-top: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 100,
}
.zx_icon{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.cart_icon{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.goShopButton{
  display: flex; 
  justify-content: center; 
  align-items: center;
  /* width: 50%; */
  /* background-color: #c22131; */
  /* color: #ffffff; */
  line-height: 25px;
  font-size: 14px;
  flex: 1;
}
.kfButton{
  width: 20%;
  display: flex;
  justify-content: center; 
  align-items: center;
  /* width: 50%; */
  /* background: #fff; */
  /* flex-direction: column;*/
}

// 商品组
.spGroup{
  .clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
  }
  .subTitle{
    font-size: 12px;
    padding: 10px 0 0 0;
    color: #333;
  }
  .title{
    font-size: 20px;
    padding: 10px 0;
  }
  
  .productBlock{ 
    position: relative;
    overflow: hidden;
    border-radius: 2px;
  }
  .productBlock .imgWrap {
    width: 100%;
    height: 168px;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
  }
  /* .productBlock .imgWrap img {
    width: 100%;
    height: 168px;
  } */
  .productBlock .goosName{
    font-size: 12px;
    line-height: 22px;
    width: 100%;
    padding-top: 10px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    height: 40px;
    overflow: hidden;
  }
  .productBlock .goosPrice{
    font-size: 16px;
  }
  .productBlock .goosPrice .symbol {
    font-size: 12px;
  }
  .buyButtonWrap .button1{
    font-size: 12px;
    border: 1px solid #f00;
    color: #f00;
    padding: 2px 8px;
    display: inline-block;
    border-radius: 3px;
  }
  .buyButtonWrap .button2{
    font-size: 12px;
    border: 1px solid #f00;
    background-color: #f00;
    color: #fff;
    padding: 2px 8px;
    display: inline-block;
    border-radius: 3px;
  }
  .button3{
    width: 80%;
    margin: 0 auto;
    border-radius: 27px;
    color: #fff;
    padding: 3px 0;
    margin-bottom: 10px;
    margin-top: 10px;
  }
    .topIcon1{
      position: absolute;
      width: 3.39rem;
      height: 2.4rem;
      background: #ff0000;
      z-index: 0;
      transform-origin: left bottom;
      -webkit-transform-origin: left bottom;
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      color: #fff;
      line-height: 3.7rem;
      font-size: 0.6rem;
      text-align: center;
  }
  
  .topIcon2{
    position: absolute;
    height: 1rem;
    width: 3.4rem;
    background: #ff7104;
    top: 1.4rem;
    color: #fff;
    font-size: 0.6rem;
    line-height: 1rem;
    text-align: center;
    transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
  }
  .topIcon3{
    position: absolute;
    width: 2.25rem;
    height: 1.2rem;
    background: #04a6f8;
    z-index: 0;
    text-align: center;
    color: #fff;
    font-size: 0.6rem;
    line-height: 1rem;
  }
  /*排版*/
  .productWrapper1, .productWrapper2, .productWrapper3{
    width: 100%;
  }
  .productWrapper1 .productBlock {
    width: 98%;
    margin: 5px auto;
    box-sizing: border-box;
  }
  .productWrapper1 .productBlock .imgWrap{
    height: 210px;
  }
  .productWrapper2 .productBlock {
    box-sizing: border-box;
    width: 46%;
    margin: 5px 2%;
    display: inline-block;
    float: left;
  }
  .productWrapper3 .productBlock{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 5px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  .productWrapper3 .productBlock .imgWrap {
    max-width: 60%;
  }
  .productWrapper3 .productBlock .rightBox {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: border-box;
    padding-right: 10px;
  }
  .productWrapper3 .productBlock .goosName{
    padding-top: 0;
  }
  .productWrapper1 .productBlock .imgWrap{
    background-size: 100% 100%;
  }
  .productWrapper3 .productBlock .imgWrap{
    background-size: 100% 100%;
  }
}

 /deep/ .van-swipe-item .vanImgs{
  max-height: 400px !important;
  overflow: hidden;
}
</style>
